import makeStyles from '@mui/styles/makeStyles';
import { largeStartBreakpoint, mobileStartBreakpoint } from '@/materialUi/theme';

export const useStyles = makeStyles((theme) => ({
  dealName: {
    marginTop: '24px',
    boxSizing: 'border-box',
    fontSize: '24px',
    lineHeight: '29px',
    [theme.breakpoints.up(mobileStartBreakpoint)]: {
      fontSize: '32px',
      padding: 'unset',
      lineHeight: '36px'
    },
    [theme.breakpoints.up(largeStartBreakpoint)]: {
      fontSize: '48px',
      lineHeight: '58px'
    }
  },
  buildYourDealText: {
    fontFamily: 'open_sans_semi',
    textTransform: 'uppercase'
  }
}));

export default { useStyles };
